<template>
  <Modal title="需代课请假" v-model="visible" width="60%">
    <Form ref="leaveForm" class="form" :label-width="100"
      :model="leaveParam" :rules="leaveRule">
      <Row>
        <Col span="4">
        <FormItem label="请假类型">
          <Select v-model="leaveParam.leaveType"  style="width:180px">
            <Option v-for="item in $constant.tchLeaveType"
                    :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="22" >
          <Form-item label="选择时间">
            <Row>
              <Col span="6">
                <Form-item prop="startTime">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间" v-model="startTime"
                    @on-change="startTimeChange"></Date-picker>
                </Form-item>
              </Col>
              <Col span="1" style="text-align: center">-</Col>
              <Col span="6">
                <Form-item prop="endTime">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="结束时间" v-model="endTime"
                    @on-change="endTimeChange"></Date-picker>
                  </Form-item>
              </Col>
              <Col span="6" style="text-align: center">
                <Button type="info" :loading="loadingSearch" @click="onBookLessonOpened">查看涉及课节</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
        <Col :span="10" >
          <Row>
            <Form-item label="请假原因类别" prop="remarkType">
              <Input v-model="leaveParam.remarkType" placeholder="不知道就问主管"></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="16">
          <Form-item label="请假原因" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="leaveParam.remark" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Table class="compact" size="small" :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList"></Table>
    <div slot="footer">
      <p style="color: red">操作后记得点击“保存”按钮</p>
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
    name: 'TchLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number,
        default: false
      },
      substituteList: {
        type: [Array],
        default: []
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      // let self = this
      let $constant = this.$constant
      let $moment = this.$moment
      return {
      rankScoreSeq: 0,
        visible: this.value,
        oldTch: null,
        bookLessonOpenedColumn: [
          {
            title: '学生ID、姓名',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('span', ' - '),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '老师ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '外教运营',
            width: 80,
            key: 'tchStudyAdviserNickname'
          },
          {
            title: '学导',
            width: 80,
            key: 'studyAdviserNickname'
          },
          {
            title: '课顾',
            width: 80,
            key: 'adviserNickname'
          },
          {
            title: '课程类型',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程类别',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let courseType = params.row.courseType
              let typeEnum = $constant.getEnum($constant.courseType, courseType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程名称',
            width: 180,
            key: 'lessonTitle'
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 122,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课时长',
            align: 'center',
            width: 72,
            key: 'courseTime'
          },
          {
            title: '上课状态',
            width: 72,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '是否代课',
            width: 70,
            key: 'isProxy',
            render: (h, params) => {
              let isProxy = params.row.isProxy
              return h('div', isProxy === 1 ? '是' : '否')
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 72,
            render: (h, params) => {
              this.oldTch = params.row.oldOpenedId
              let courseType = params.row.courseType
              let isProxy = params.row.isProxy
              if (courseType === 8) {
                if (isProxy === 1) {
                  return h('a', { on: { click: () => this.cancelProxyClass(params.row) } }, '取消代课')
                } else {
                  return h('a', { on: { click: () => this.proxyClass(params.row) } }, '代课')
                }
              }
            }
          }
        ],
        bookLessonOpenedList: [],
        loadingSearch: false,
        loadingAdd: false,
        leaveParam: {
          leaveType: 1,
          startTime: '',
          remark: '',
          remarkType: '',
          endTime: ''
        },
        leaveRule: {
          startTime: [
            { required: true, message: '请选择开始时间', trigger: 'blur' },
            { validator (rule, value, callback, source, options) {
              // let endTime = self.leaveParam.endTime
              let errors = []
              // let nowTime = new Date().getTime() / 1000
              // if (nowTime >= value) {
              //   errors.push('开始时间应在当前时间之后')
              // }
              // if (endTime !== '' && value >= endTime) {
              //   errors.push('开始时间应在结束时间之前')
              // }
              callback(errors)
            } }
          ],
          endTime: [
            { required: true, message: '请选择结束时间', trigger: 'blur' }
          ],
          remark: [
            { type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
        startTime: '',
        endTime: '',
        remarkType: [
             { type: 'string', required: true, message: '请填写请假原因类别', trigger: 'blur' },
            { type: 'string', max: 100, message: '不知道就问主管', trigger: 'blur' }
        ]
      }
    },
    methods: {
    loadMonthRankScores () {
      const table = this.bookLessonOpenedList
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

      add () {
        let self = this
        this.$refs.leaveForm.validate((valid) => {
          if (!valid) {
            return
          }
          self.loadingAdd = true
          let params = self.leaveParam
          params.tchId = self.tchId
          let tchList = []
          this.substituteList.map(item => {
            if (item.isProxy === 1) {
              tchList.push({id: item.id, tchId: item.substituteTchId})
            }
          })
          if (this.substituteList) {
            params.substituteListJson = JSON.stringify(tchList)
          }
          self.$http.post('/bookTchLeaveTime/add', params).then(function (res) {
            self.loadingAdd = false
            if (res && res.data > 0) {
//              self.successCallback()
              self.$Message.success('请假成功!')
              self.visible = false
              this.substituteList = []
            }
          }).catch(function (e) {
            self.loadingAdd = false
          })
        })
      },
      startTimeChange (value) {
        this.leaveParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeChange (value) {
        this.leaveParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onBookLessonOpened () {
        let self = this
        let isNotError = true
        this.$refs.leaveForm.validateField('startTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        this.$refs.leaveForm.validateField('endTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) return
        self.loadingSearch = true
        let params = {}
        params.tchId = self.tchId
        params.startTime = self.leaveParam.startTime
        params.endTime = self.leaveParam.endTime
        self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
          self.loadingSearch = false
          if (res.data.length <= 0) {
            self.$Message.info('没有涉及任何课节!')
            self.bookLessonOpenedList = []
            return
          }
          self.bookLessonOpenedList = res.data
          self.loadMonthRankScores()
          self.bookLessonOpenedList.map(item => {
            if (item.oldTch > 0) {
              item.isProxy = 1
            } else {
              item.isProxy = 0
            }
          })
        })
      },
      proxyClass (row) {
        row.show = true
        this.$emit('getProxyClassData', row)
      },
      cancelProxyClass (row) {
        this.$emit('getCancelProxyClassData', row)
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
        }
        this.startTime = ''
        this.endTime = ''
        this.leaveParam.startTime = ''
        this.leaveParam.endTime = ''
        this.leaveParam.remark = ''
        this.leaveParam.remarkType = ''
        this.leaveParam.leaveType = 1
        this.bookLessonOpenedList = []
        this.$emit('input', val)
      },
      substituteList (val) {
        console.log(`val`, val)
        this.bookLessonOpenedList = this.bookLessonOpenedList.map(item => {
          val.map(i => {
            if (item.id === i.id) {
              item = i
            }
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchLeaveModal.vue?8a06fe54